import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllNationalities = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetNationalities}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getNationalityById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.NationalityAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertNationality = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.NationalityAPI, input);
  return data;
};

const updateNationality = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.NationalityAPI, input);
  return data;
};

const deleteNationality = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.NationalityAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetNationalitiesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetNationalities],
    queryFn: () => getAllNationalities(input),
     refetchOnWindowFocus: false,
    // staleTime: 1000 * 60 * 60,
    // cacheTime: 1000 * 60 * 60 * 2,
  });
};

export const useGetNationalityByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.NationalityAPI],
    queryFn: () => getNationalityById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertNationalityMutation = () => {
  return useMutation({
    mutationFn: insertNationality,
  });
};

export const useUpdateNationalityMutation = () => {
  return useMutation({
    mutationFn: updateNationality,
  });
};

export const useDeleteNationalityMutation = () => {
  return useMutation({
    mutationFn: deleteNationality,
  });
};
